import React, { Suspense } from "react";
import { graphql, useFragment } from "react-relay";
import { ToolbarFeature } from "widgets/src/Todo/TodoToolbar/TodoToolbarItem";
import { TVTodoPopovers_todo$key } from "./__generated__/TVTodoPopovers_todo.graphql";
import { TodoEditPrioPopover } from "widgets/src/Todo/TodoPopovers/TodoEditPrioPopover";
import { TVTodoTeamsPopover } from "./TVTodoTeamsPopover";
import { TodoEditTagsPopover } from "widgets/src/Todo/TodoPopovers/TodoEditTagsPopover";
import { TVTodoEditAssigneesPopover } from "./TVTodoAssigneesPopover/TVTodoEditAssigneesPopover";
export function TVTodoPopovers(props: {
  todo: TVTodoPopovers_todo$key;
  openFeature: ToolbarFeature | null;
  dismissFeature: () => void;
}) {
  const todo = useFragment(
    graphql`
      fragment TVTodoPopovers_todo on Todo {
        ...TodoEditPrioPopover_todo
        ...TodoEditTagsPopover_todo
        id
        teams {
          id
        }
        assignedRoles {
          id
          role {
            id
            team {
              id
            }
          }
        }
        #        ...TodoEditTagsPopover_todo
        #       ...TodoEditNewMainNotificationPopover_todo
        #      ...TodoEditDeadlinePopover_todo
      }
    `,
    props.todo
  );
  return (
    <Suspense fallback={null}>
      <TodoEditPrioPopover
        todo={todo}
        visible={props.openFeature === "PRIORITY"}
        onClose={props.dismissFeature}
        currentEmployeeId={null}
      />
      <TVTodoTeamsPopover
        todoId={todo.id}
        selectedTeamIds={todo.teams.map((t) => t.id)}
        assignedRoles={todo.assignedRoles}
        visible={props.openFeature === "TEAM"}
        onClose={props.dismissFeature}
      />
      <TodoEditTagsPopover
        todo={todo}
        visible={props.openFeature === "TAG"}
        onClose={props.dismissFeature}
        currentEmployeeId={null}
      />
      <TVTodoEditAssigneesPopover
        todoId={todo.id}
        visible={props.openFeature === "ASSIGNEE"}
        onClose={props.dismissFeature}
      />
    </Suspense>
  );
}

/*

<TodoEditTagsPopover
        todo={todo}
        visible={props.openFeature === "TAG"}
        onClose={props.dismissFeature}
        setStatus={props.setStatus}
      />
      <TodoEditDeadlinePopover
        todo={todo}
        onClose={props.dismissFeature}
        visible={props.openFeature === "DEADLINE"}
      />
      <TodoEditTeamsPopover
        todoId={todo.id}
        selectedTeamIds={todo.teams.map((t) => t.id)}
        visible={props.openFeature === "TEAM"}
        onClose={props.dismissFeature}
        setStatus={props.setStatus}
      />
      <TodoEditNewMainNotificationPopover
        todo={todo}
        visible={props.openFeature === "REMIND_NOTIFICATION"}
        onClose={props.dismissFeature}
      />
      <TodoEditAssigneesPopover
        todoId={todo.id}
        visible={props.openFeature === "ASSIGNEE"}
        onClose={props.dismissFeature}
        setStatus={props.setStatus}
      />

      */
